import { Col, Row } from 'react-bootstrap';
import { ApproveDenyButtons } from '../ApproveDenyButtons';
import { BadgePill } from 'src/Admin/components/common/Badge';
import { PendingIconSVG } from 'src/Admin/img/EnrollmentRequest/EnrollmentRequestIcons';

export const OverviewCard = () => {
  return (
    <div className="details-overview-card">
      <div className="details-block">
        <Row className="detail-row">
          <Col md={4} className="detail-row">
            <p className="common-label">Request Submitted by</p>
            <p className="common-value bold-value">John Smith (Employer)</p>
          </Col>
          <Col md={4} className="detail-row">
            <p className="common-label">Request Type</p>
            <p className="common-value">Open Enrollment</p>
          </Col>
          <Col md={4} className="detail-row">
            <p className="common-label">Member</p>
            <p className="common-value">Katherine Marie</p>
          </Col>
          {/*</Row>
        <Row className="detail-row"> */}
          <Col md={4} className="detail-row">
            <p className="common-label">Client & Location</p>
            <p className="common-value">Apex Business Solutions, Florida</p>
          </Col>
          <Col md={4} className="detail-row">
            <p className="common-label">Submitted On</p>
            <p className="common-value">11-23-2023</p>
          </Col>
          {/*<Col md={4} className="detail-row">
            <p className="common-label">Submitted On</p>
            <p className="common-value">11-23-2023</p>
          </Col> */}
          {/*</Row>
        <Row className="detail-row"> */}
          {/*<Col md={4} className="detail-row">
            <p className="common-label">Request Type</p>
            <p className="common-value">Open Enrollment</p>
          </Col> */}
          <Col md={4} className="detail-row">
            <p className="common-label">Status</p>
            <p className="common-value">
              <BadgePill
                text={'Pending'}
                //prefixIcon={<PendingIconSVG className={PendingIconSVG} />}
                prefixIcon={'pending'}
                variant="info"
                className={'badge-with-border'}
              />
            </p>
          </Col>
        </Row>
      </div>
      <div className="buttons-block text-right">
        <Row>
          <Col>
            <ApproveDenyButtons isFromDetailsPage={true} />
          </Col>
        </Row>
      </div>
    </div>
  );
};
